"use strict";

var _interopRequireDefault = require("D:/a2/Code_New/Web/node_modules/@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.listData = listData;
exports.createData = createData;
exports.deleteData = deleteData;

var _request = _interopRequireDefault(require("@/utils/request"));

function listData(query) {
  return (0, _request.default)({
    url: '/baseData/list',
    method: 'get',
    params: query
  });
}

function createData(data) {
  return (0, _request.default)({
    url: '/baseData/create',
    method: 'post',
    data: data
  });
}

function deleteData(data) {
  return (0, _request.default)({
    url: '/baseData/delete',
    method: 'post',
    data: data
  });
}